// Used to prevent circle dependency.

export const marginAfterHeader = '4rem';
export const marginAfterLastItem = '2rem';
export const paddingX = '1.2rem';
